const bgs = ['bg-white', 'bg-offWhite', 'bg-defaultBgGray']
const bgsFill = ['fill-white', 'fill-offWhite', 'fill-defaultBgGray']

export const getPageBackground = (value?: string, asFill?: boolean) => {
  let index = bgs.findIndex((bg) => bg === value)
  if (index === -1) index = 0

  const relevantArray = asFill ? bgsFill : bgs
  return relevantArray[index]
}
